import Vue from 'vue'
import Vuex from 'vuex'
import BankingStore from './stores/banking-store'
import CurrencyStore from './stores/currency-store'
import OperationDefinitionStore from './stores/operation-definition-store'
import PartyRoleTypeStore from './stores/party-role-type-store'
import PartyStore from './stores/party-store'
import CashflowSetupStore from './stores/cashflow-setup-store'
import CashflowReportStore from './stores/cashflow-report-store'
import CashflowReportDefinitionStore from './stores/cashflow-report-definition-store'
import CashflowReportColumnStore from './stores/cashflow-report-columns-store'
import CashEventGenerationScriptStore from './stores/cash-event-generation-script-store'
import AccountOwnershipStore from './stores/account-ownership-store'
import OperationQueryStore from './stores/operation-query-store'
import CashEventQueryStore from './stores/cash-event-query-store'
import CashEffectQueryStore from './stores/cash-effect-query-store'
import CashEventFieldDistinctsStore from './stores/cash-event-field-distincts-store'
import FrontendStore from './stores/frontend-store'
import PaymentBatchesStore from './stores/payment-batch-store'
import PaymentStore from './stores/payment-store'
import CashEventStore from './stores/cash-event-store'
import CashEffectStore from './stores/cash-effect-store'
import ImportFileStore from './stores/import-file-store'
import ImportDefinitionStore from './stores/import-definition-store'
import ImportMappingStore from './stores/import-mapping-store'
import ImportProcessStore from './stores/import-process-store'
import AuthStore from './stores/auth-store'
import UserStore from './stores/user-store'
import SecurityGroupStore from './stores/security-group-store'
import JobScheduleStore from './stores/job-schedule-store'
import DashboardStore from './stores/dashboard-store'
import ReconciliationStore from './stores/reconciliation-store'
import AccountBalanceStore from './stores/account-balance-store'
import AccountBalanceItemStore from './stores/account-balance-item-store'
import AccountQueryStore from './stores/account-query-store'
import ReconciliationMatchesStore from './stores/reconciliation-match-store'
import ReconciliationQueryStore from './stores/reconciliation-query-store'
import CreditRiskStore from './stores/credit-risk-store'
import PersonalizationStore from './stores/personalization-store'
import OperationIndexStore from './stores/operation-index-store'
import OperationStore from './stores/operations-store'
import OperationDefinitionGroupStore from './stores/operation-definition-group-store'
import ProcessQueryStore from './stores/process-query-store'
import OperationLinkDefinitionStore from './stores/operation-link-definition-store'
import OperationLinkStore from './stores/operation-link-store'
import CommandStore from './stores/commands-store'
import ExchangeRateStore from './stores/exchange-rates-store'
import UserPreferencesStore from './stores/user-preferences-store'
import VolatilitiesStore from './stores/volatility-store'
import ImportFileQueryStore from "./stores/import-file-query-store";
import ComparisonStore from "./stores/comparison-store";

Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        banking: BankingStore(),
        currencies: CurrencyStore,
        volatilities: VolatilitiesStore,
        operationDefinitions: OperationDefinitionStore,
        partyRoleTypes: PartyRoleTypeStore,
        parties: PartyStore,
        cashflowSetups: CashflowSetupStore,
        cashflowReports: CashflowReportStore,
        cashflowReportDefinitions: CashflowReportDefinitionStore,
        cashflowReportColumns: CashflowReportColumnStore,
        cashEventFieldDistincts: CashEventFieldDistinctsStore,
        cashEventGenerationScripts: CashEventGenerationScriptStore,
        accountOwnerships: AccountOwnershipStore,
        operationQueries: OperationQueryStore,
        cashEventQueries: CashEventQueryStore,
        cashEffectQueries: CashEffectQueryStore,
        paymentBatches: PaymentBatchesStore,
        payments: PaymentStore(),
        gui: FrontendStore,
        cashEvents: CashEventStore,
        cashEffects: CashEffectStore,
        importFiles: ImportFileStore(),
        importDefinitions: ImportDefinitionStore,
        importMappings: ImportMappingStore,
        importProcesses: ImportProcessStore,
        auth: AuthStore,
        users: UserStore,
        jobSchedules: JobScheduleStore,
        dashboards: DashboardStore,
        reconciliations: ReconciliationStore,
        accountBalances: AccountBalanceStore,
        accountBalanceItems: AccountBalanceItemStore(),
        accountQueries: AccountQueryStore,
        importFileQueries: ImportFileQueryStore,
        reconciliationMatchs: ReconciliationMatchesStore,
        reconciliationQueries: ReconciliationQueryStore,
        creditRisk: CreditRiskStore,
        personalization: PersonalizationStore(),
        operationIndices: OperationIndexStore,
        processQueries: ProcessQueryStore,
        securityGroups: SecurityGroupStore,
        operationDefinitionGroups: OperationDefinitionGroupStore,
        operationLinkDefinitions: OperationLinkDefinitionStore,
        operationLinks: OperationLinkStore,
        operations: OperationStore(null),
        commands: CommandStore,
        exchangeRates: ExchangeRateStore,
        userPreferences: UserPreferencesStore(),
        comparison: ComparisonStore,
    }
})
